import { useEffect, useRef } from "react";
import { trackPageView } from "@/lib/analytics";

/**
 * Envoie un page_view a chaque changement de `path`.
 * Aucune route hardcodee : le chemin est passe en parametre.
 */
export function useAnalyticsPageView(path: string): void {
  const last = useRef<string | null>(null);
  useEffect(() => {
    if (last.current === path) return;
    // Back-office : aucune mesure (usage interne).
    if (path.startsWith("/admin")) return;
    last.current = path;
    trackPageView(path);
  }, [path]);
}
